/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_H2Inputs */

const en_csv_to_json_ref_h2 = /** @type {(inputs: Csv_To_Json_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON output`)
};

const ko_csv_to_json_ref_h2 = /** @type {(inputs: Csv_To_Json_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 출력`)
};

const ja_csv_to_json_ref_h2 = /** @type {(inputs: Csv_To_Json_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 出力`)
};

/**
* | output |
* | --- |
* | "JSON output" |
*
* @param {Csv_To_Json_Ref_H2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_h2 = /** @type {((inputs?: Csv_To_Json_Ref_H2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_H2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_h2(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_h2(inputs)
	return ja_csv_to_json_ref_h2(inputs)
});